import React from 'react';
import "./css/Contact.css";
import mailIcon from "./resources/mail.svg"

function Contact() {
    return (
        <div className="contact">
            <a href="mailto:abansal619@gmail.com"><img src={mailIcon} alt="mail" className="contact__mail"/></a>
            <h1>Click Here to Contact Me</h1>
        </div>
    )
}

export default Contact
